import { gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { ItemCategory, ItemCategoryFindRequest, ItemCategoryListFindRequest, ItemCategoryListItem } from '../type'
import { ItemFindRequest } from '../type/item-query'

export const GetItemCategories: TypedDocumentNode<
QueryPageableResponse<ItemCategory, 'itemCategoriesFind'>,
QueryPageableRequest<ItemCategoryFindRequest>> = gql`
    query GetItemCategoriesFind($request: ItemCategoryFindRequest!) {
        itemCategoriesFind(request: $request) {
            data {
                id
                title
                level
            }
            count
        }
    }
`

export const GetItemCategoriesForLookup: TypedDocumentNode<
    QueryPageableResponse<ItemCategory, 'itemCategoriesFind'>,
    QueryPageableRequest<ItemCategoryFindRequest>> = gql`
    query GetItemCategoriesFindLookup($request: ItemCategoryFindRequest!) {
        itemCategoriesFind(request: $request) {
            data {
                id
                title
                level
                parent {
                    id
                }
            }
        }
    }

`

export const GetItemCategoryList: TypedDocumentNode<
  QueryPageableResponse<ItemCategoryListItem, 'itemCategoryListFind'>,
  QueryPageableRequest<ItemCategoryListFindRequest>> = gql`
    query GetItemCategoryList($request: ItemCategoryListFindRequest!) {
        itemCategoryListFind(request: $request) {
            data {
                id
                title
                level
                used
                showOnline
            }
            count
        }
    }
`

export const ItemCategoryUpdateMutation: TypedDocumentNode<void, {id: number, input: {title:string}}> = gql`
    mutation ItemCategoryMutation($id: Int!, $input: ItemCategoryUpdateInput!) {
        itemCategoryUpdate(id: $id, input: $input) 
    }
`

export const ItemCategoryDeleteMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation ItemCategoryDeleteMutation($id: Int!) {
        itemCategoryDelete(id: $id) 
    }
`
export const ItemCategoryEnableShowOnlineMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation ItemCategoryEnableShowOnlineMutation($id: Int!) {
        itemCategoryEnableShowOnline(id: $id) 
    }
`
export const ItemCategoryDisableShowOnlineMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation ItemCategoryDisableShowOnlineMutation($id: Int!) {
        itemCategoryDisableShowOnline(id: $id) 
    }
` 

export const ItemCategoryDeleteUnusedMutation: TypedDocumentNode<void, void> = gql`
    mutation ItemCategoryDeleteUnusedMutation {
        itemCategoryDeleteUnused 
    }
`

export const GetItemCountByCategory: TypedDocumentNode<
  { itemsFind: { data: { id: number }[], count: number } },
  QueryPageableRequest<ItemFindRequest>
> = gql`
    query GetItemCountByCategory($request: ItemFindRequest!) {
        itemsFind(request: $request) {
            data {
                id
            }
            count
        }
    }
`